module.exports = __webpack_public_path__ + "img/ice-breaker-dude.568cbe44.svg";